import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getPromotions = createAsyncThunk(
  'promotion/getPromotion',
  async () => {
    const promotion = await instanceAPI.get('/get-carousel-footer')
      .then((resp) => resp.data.carouselFooter);
    return promotion;
  },
);

const promotionSlice = createSlice({
  name: 'promotion',
  initialState: {
    promotions: [],
    status: null,
    selected: [],
  },
  reducers: {
    itemSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: {
    [getPromotions.pending]: (state) => {
      state.status = 'loading';
    },
    [getPromotions.fulfilled]: (state, action) => {
      state.status = 'success';
      state.promotions = action.payload;
    },
    [getPromotions.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});
export const { itemSelected } = promotionSlice.actions;
export default promotionSlice.reducer;
